import Axios from "axios";

export const SelectBLBR = (f, g, a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/BLBRs?type=br&VENDEUR=${f}&grp=${g}&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "BLBR_SELECT", payload: response.data });
    });
  };
};
